module.exports = __webpack_public_path__ + "img/icon-filter.19776efc.svg";